import React from 'react';

export const selectedItems = React.createContext({});
export const filter = React.createContext({});
export const depth = React.createContext({});
